'use client'

import React, { use, useMemo } from 'react'
import { Button, BaseButtonProps, DictionaryText } from '../../../atoms'
import { NotificationContext } from '../../../../providers/notification-provider'
import { FixedNotification } from '../FixedNotification'
import { groupNotificationsForDisplay } from '../helpers/groupNotificationsForDisplay'

export interface FixedNotificationActionButtonProps extends BaseButtonProps {
    /** Key to translate for inside the action button */
    textKey: string
    /** Route for the on-click of the action */
    route: string
}

export interface FixedNotificationsListProps extends React.HTMLAttributes<HTMLDivElement> {
    dismissLabel: string
    onNavigate?: (route: string) => void
}

const parseActions = (actions: string | undefined): FixedNotificationActionButtonProps[] =>
    actions ? (JSON.parse(actions) as FixedNotificationActionButtonProps[]) : []

export const FixedNotificationsList = ({
    dismissLabel,
    onNavigate,
    className,
    ...props
}: FixedNotificationsListProps) => {
    const { notifications, remove } = use(NotificationContext)

    const displayItems = useMemo(() => groupNotificationsForDisplay(notifications), [notifications])

    const removeGroup = (ids: string[]) => {
        ids.forEach((id) => remove(id))
    }

    return (
        <div {...props} className={`flex flex-col gap-2 ${className ? className : ''}`}>
            {displayItems.map((item) => (
                <FixedNotification
                    key={item.notification.id}
                    id={item.notification.id}
                    message={item.notification.message}
                    title={item.displayTitle}
                    variant={item.notification.variant}
                    actions={parseActions(item.notification.actions).map(
                        (actionProps: FixedNotificationActionButtonProps) => (
                            <Button
                                {...actionProps}
                                key={actionProps.textKey}
                                onClick={() =>
                                    actionProps.route && onNavigate ? onNavigate(actionProps.route) : undefined
                                }
                            >
                                <DictionaryText textKey={actionProps.textKey} />
                            </Button>
                        )
                    )}
                    dismissLabel={dismissLabel}
                    onRemove={() => removeGroup(item.ids)}
                />
            ))}
        </div>
    )
}
